import Section from './Section';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@tanstack/react-query';
import { fetchConfig } from '@/lib/api';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioButton from '@/components/RadioButton/RadioButton';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';

const Rtp = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[][];
  onChange: (values: string[][]) => void;
  mode?: 'light' | 'dark';
}) => {
  const { data, isError } = useQuery({
    queryKey: ['config'],
    queryFn: fetchConfig,
  });
  const rtpItems =
    data?.filters.rtps.map(({ name, value }) => ({
      id: name,
      value,
    })) || [];
  const groupValue =
    rtpItems?.find?.(
      ({ value: rtpValue }) =>
        rtpValue[0] === value?.[0]?.[0] &&
        rtpValue[1] === value?.[0]?.[1],
    )?.id || '';

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const rtpId = (event.target as HTMLInputElement).value;
    const rtpValue = rtpItems.find(({ id }) => id === rtpId);

    onChange([rtpValue?.value || []]);
  };

  const isDefaultValue =
    value.length === 1 &&
    value[0]?.[0] === '1' &&
    value[0]?.[1] === '100';
  const hasInitialValue = !isDefaultValue;
  return (
    <Section
      title={<FormattedMessage id="rtp" defaultMessage="RTP" />}
      aria-label="RTP filter"
      mode={mode}
      defaultOpen={hasInitialValue}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        <Content>
          <StyledFormControl>
            <RadioGroup
              value={groupValue}
              name="rtp"
              onChange={handleChange}
            >
              {rtpItems.map(({ id }) => (
                <FormControlLabel
                  key={id}
                  value={id}
                  control={<RadioButton mode={mode} />}
                  label={id}
                  aria-label={`Select ${id} RTP`}
                />
              ))}
            </RadioGroup>
          </StyledFormControl>
        </Content>
      )}
    </Section>
  );
};

const Content = styled('div')({
  display: 'block',
  height: '180px',
});

const StyledFormControl = styled(FormControl)({
  display: 'block',
  height: '180px',
  maxHeight: '180px',
  overflowY: 'auto',
});

export default Rtp;
